<template>
  <div class='fixed-bottom'>
    <div class='button'>
      <div class='kakao' v-on:click='kakao'>
        <img :src='kakaoImg'>
      </div>
      <div class='call' v-on:click='call'>
        <img :src='callImg'>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    components: {

    },
    data() {
      return {
        callImg: require('@/assets/call.png'),
        kakaoImg: require('@/assets/kakao.png'),
      }
    },
    mounted() {
      this.blink();
    },
    methods: {
      kakao: function () {
        location.href = 'https://open.kakao.com/o/s6Dioohf';
      },
      call: function () {
        location.href = 'tel:1600-2240';
      },
      blink: function () {
        setTimeout(()=>{
          this.callImg = require('@/assets/call.png');
          this.kakaoImg = require('@/assets/kakao.png');
          this.blink2();
        }, 300);
      },
      blink2: function () {
        setTimeout(()=>{
          this.callImg = require('@/assets/call-black.png');
          this.kakaoImg = require('@/assets/kakao-yellow.png');
          this.blink();
        }, 300);
      }
    }
  }
</script>

<style scoped>
  /* fixed bottom */
  .fixed-bottom {
    width: 100%;
    margin: 0 auto;
    position: fixed;
    z-index: 2;
    bottom: -11px;
    left: 0;
    right: 0;
  }
  .button {
    display: flex;
    justify-content: center;
  }
  .kakao img{
    width: 100%;
  }
  .call img{
    width: 100%;
  }
</style>
